export const INVITATION_VERSION = 'invitationVersion' as const
export const INVITATION_IV = 'invitationIv' as const
export const INVITATION = 'invitation' as const
